<template>
        <div class="warp" >
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'系统配置'},{name:'广告栏管理',goback:true},{name:sendInfo.id?'编辑广告栏':'添加广告栏'}]" :title="sendInfo.id?'编辑广告栏':'添加广告栏'"/>
            <!-- 表单 -->
            <div class="box" v-loading="loading"
                element-loading-text="请求中......">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>广告图片：</div>
                        <div class="content">
                          <upLoad :action="'backstage/annex/file'"  is-need-limit
                                  @input="inputValue" :accept="'image/png,image/jpg,image/jpeg'" 
                                  :size="20" :value="sendInfo.logo" :sizeList="[6 / 5]" :fixedNumber='[6,5]'
                                  :autoCropWidth="120"
                                  :autoCropHeight='100'/>
                        </div>
                    </div>
                    <div class="hint">图片仅支持png、jpg格式，建议尺寸为120*100px</div>
                    <div class="error" v-if="errors['sendInfo.logo']">错误提示：{{errors['sendInfo.logo']}}</div>

                    <div class="child">
                        <div class="name"><span>*</span>广告名称：</div>
                        <el-input v-model="sendInfo.adName" maxlength="20" placeholder="限20字"></el-input>
                    </div>
                    <div class="error" v-if="errors['sendInfo.adName']">错误提示：{{errors['sendInfo.adName']}}</div>

                    <div class="child">
                        <div class="name"><span>*</span>链接：</div>
                        <el-radio-group v-model="sendInfo.sourceType">
                            <el-radio :label="0">内部模块</el-radio>
                            <el-radio :label="1">链接地址</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                          <div class="child childList" v-show="sendInfo.sourceType==0" @change="setAddress">
                              <el-radio-group v-model="sendInfo.source">
                                  <el-radio :label="item.id" v-for="(item,index) in childList" :key="index" v-if="item.moduleName 
                                  !== '首页'">{{item.moduleName}}</el-radio>
                              </el-radio-group>
                          </div>
                          <div class="child"  @input="setAddress">
                              <el-input v-model="sendInfo.websiteLink"></el-input>
                          </div>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.sourceType']">错误提示：{{errors['sendInfo.sourceType']}}</div>
                    <div class="error" v-if="errors['sendInfo.websiteLink']">错误提示：{{errors['sendInfo.websiteLink']}}</div>
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                          <div class="singleBtn"><el-button type="primary" size="small" @click="submit">发布</el-button></div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <!-- <el-dialog title="选择详情" :visible.sync="dialogTableVisible">
                <el-table :data="gridData">
                  <el-table-column property="date" label="日期" width="150"></el-table-column>
                  <el-table-column property="name" label="姓名" width="200"></el-table-column>
                  <el-table-column property="address" label="地址"></el-table-column>
                </el-table>
              </el-dialog> -->
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import upLoad from '../../components/upLoads';
export default {
    components:{
        breadcrumb,
        upLoad
    },
    data(){
        return{
            loading:false,
            dialogTableVisible:false,
            type:void 0,
            id: void 0,
            sendInfo:{
                id:'',
                logo:'',//图片
                adName:'',//banner名称
                sourceType:null,//链接类型
                source:null,//内部模块子选项
                websiteLink:'',//链接地址
                relationId: void 0, // 关联模块外键id
            },
            childList:[
                    {moduleName:'外部链接',id:0},
                    {moduleName:'债权需求',id:1},
                    {moduleName:'债权产品',id:2},
                    {moduleName:'合作银行',id:3},
                    {moduleName:'融资租赁',id:4},
                    {moduleName:'股权项目',id:5},
                    {moduleName:'政策资讯',id:6},
                    {moduleName:'政策申报',id:7},
                    {moduleName:'活动沙龙',id:8}
                ],//内部模块子选项数组
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfo.logo':{
            test:function(){
                if(this.sendInfo.logo){
                    return true;
                }else{
                    return false;
                }
            },
            message:'上传广告图片'
        },
        'sendInfo.adName':{
            test:function(){
                if(this.sendInfo.adName.length>0){
                    return true;
                }else{
                    return false;
                }
            },
            message:'输入广告名称'
        },
        'sendInfo.sourceType':{
            test:function(){
                if(this.sendInfo.sourceType == 0){
                    if(this.sendInfo.source){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    let reg = /(http|https):\/\/([\w.]+\/?)\S*/
                    return reg.test(this.sendInfo.websiteLink)
                }
            },
            message:'选择内部模块或填写链接地址'
        },
        'sendInfo.websiteLink':{
            test:function(val){
                if(val){
                    let reg = /(http|https):\/\/([\w.]+\/?)\S*/
                    return reg.test(val)
                }else{
                    return false
                }
            },
            message:'请填写链接地址'
        }
    },
    created(){
      const {id } = this.$route.params
      this.id = id || void 0
      this.sendInfo.id = id || void 0
      if(id) this.getData()

    },
    mounted(){
        // if(this.$route.query.id){
        //     this.sendInfo.id = this.$route.query.id
        //     this.sendInfo.logo = this.$route.query.logo
        //     this.sendInfo.adName = this.$route.query.adName
        //     this.sendInfo.sourceType = this.$route.query.sourceType
        //     this.sendInfo.source = this.$route.query.source
        //     this.sendInfo.websiteLink = this.$route.query.websiteLink
        // }
        this.$axiosc.get('backstage/banner/internal/module/list').then(res=>{
            if(res.code == 200){
                this.childList = res.data
            }
        })
    },
    methods:{
        //根据选择和输入 重置链接的错误信息
        setAddress:function(){
            this.$vuerify.check(['sendInfo.sourceType']);
        },
        inputValue(value){
            this.sendInfo.logo = value
        },
        //发布
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                if(this.sendInfo.sourceType == 0){
                    this.sendInfo.websiteLink = null
                }else{
                    this.sendInfo.source = ''
                }
                this.$axioscBody.post('/backstage/portalAd/save',this.sendInfo).then(res=>{
                    if(res.code == 200){
                        this.$router.back()
                        this.$message({
                            type: 'success',
                            message: this.sendInfo.id?"修改成功":'添加成功!'
                        });
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            }
        },
        async getData(){
          this.loading = true
          const {code,data,msg} = await this.$axiosc.get(`/backstage/portalAd/details/${this.id}`)
          if(code === 200) this.sendInfo = Object.assign(this.sendInfo,data)
          this.loading = false
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:93%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding:100px 0;
    border-top: 1px solid rgba(112, 112, 112, 0.1);
    .forms{
            max-width: 610px;
            margin: auto;
            transform: translateX(-100px);
            .child{
                .name{
                  width:80px;
                  text-align: right;
                  margin-right:10px;
                }
                .content{
                    flex: 1;
					/deep/ .ql-container{
						min-height: 410px;
					}
                }
            }
        }
    }
    .childList{
        max-width: 700px;
        /deep/ .el-radio{
            margin-top: 10px;
            width: 100px;
        }
    }
}
.error{
  text-indent: 95px !important;
}
</style>